class WWFCTestSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.wwfc-test-slider__track');
    this.dots = Array.from(el.querySelectorAll('.wwfc-test-slider__dot'));
    this.total = this.dots.length;
    this.current = 0;
    this.delay = Number(el.dataset.autoplay || 0) * 1000;
    this.timer = null;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index));
    });

    el.querySelector('.wwfc-test-slider__arrow--prev')?.addEventListener('click', () => {
      this.goTo((this.current - 1 + this.total) % this.total);
    });

    el.querySelector('.wwfc-test-slider__arrow--next')?.addEventListener('click', () => {
      this.goTo((this.current + 1) % this.total);
    });

    if (this.delay > 0 && this.total > 1) {
      this.start();
    }
  }

  start() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.goTo((this.current + 1) % this.total);
    }, this.delay);
  }

  goTo(index) {
    this.current = index;
    this.track.style.transform = `translateX(-${index * 100}%)`;
    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
    if (this.delay > 0 && this.total > 1) {
      this.start();
    }
  }
}

class WWFCTestCarousel {
  constructor(el) {
    this.track = el.querySelector('.wwfc-test-carousel__track');
    if (!this.track) return;

    el.querySelector('.wwfc-test-carousel__arrow--prev')?.addEventListener('click', () => {
      this.track.scrollBy({ left: -this.track.clientWidth * 0.85, behavior: 'smooth' });
    });

    el.querySelector('.wwfc-test-carousel__arrow--next')?.addEventListener('click', () => {
      this.track.scrollBy({ left: this.track.clientWidth * 0.85, behavior: 'smooth' });
    });
  }
}

class WWFCTestRecommendations {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.wwfc-test-carousel__track');
    this.limit = Number(el.dataset.limit || 8);
    this.fallback = el.dataset.fallback || '';
    this.customerProducts = this.parseProductIds(el.dataset.customerProducts || '');
    this.moneyFormat = window.wwfcMoneyFormat || '£{{amount}}';
    this.load();
  }

  async load() {
    const seedProducts = this.uniqueProductIds([...this.customerProducts, ...this.getViewedProducts()]).slice(0, 6);
    if (seedProducts.length && await this.loadRecommendations(seedProducts)) return;
    if (this.fallback) await this.loadCollection(this.fallback);
  }

  async loadRecommendations(productIds) {
    try {
      const products = [];
      const seen = new Set(productIds.map(String));

      for (const productId of productIds) {
        const response = await fetch(`${this.routesRoot()}recommendations/products.json?product_id=${productId}&limit=${this.limit}&intent=related`);
        if (!response.ok) continue;

        const json = await response.json();
        for (const product of json.products || []) {
          const id = String(product.id);
          if (seen.has(id)) continue;

          seen.add(id);
          products.push(product);
          if (products.length >= this.limit) {
            this.render(products);
            return true;
          }
        }
      }

      if (!products.length) return false;
      this.render(products);
      return true;
    } catch (_) {
      return false;
    }
  }

  async loadCollection(handle) {
    try {
      const response = await fetch(`${this.routesRoot()}collections/${handle}/products.json?limit=${this.limit}`);
      const json = await response.json();
      if (json.products && json.products.length) this.render(json.products);
    } catch (_) {}
  }

  render(products) {
    this.track.innerHTML = products.map((product) => {
      const image = product.images && product.images[0];
      const variant = product.variants && product.variants[0];
      const isComingSoon = this.isComingSoon(product);
      return `
        <a href="/products/${product.handle}" class="wwfc-test-product-card">
          <div class="wwfc-test-product-card__media">
            ${image ? `<img src="${this.imageUrl(image.src)}" alt="${this.escape(image.alt || product.title)}" loading="lazy">` : ''}
          </div>
          ${isComingSoon ? '<div class="wwfc-badges"><span class="wwfc-badge wwfc-badge--coming-soon">Coming soon</span></div>' : ''}
          <p class="wwfc-test-product-card__title">${this.escape(product.title)}</p>
          ${isComingSoon ? '' : `<p class="wwfc-test-product-card__price">${this.money(variant ? variant.price : product.price)}</p>`}
        </a>
      `;
    }).join('');
  }

  imageUrl(src) {
    return src.replace(/(\\.(?:jpg|jpeg|png|webp))(\\?.*)?$/i, '_500x$1$2');
  }

  money(value) {
    const numeric = Number(value);
    const amount = numeric > 999 ? numeric / 100 : numeric;
    return this.moneyFormat
      .replace('{{amount}}', amount.toFixed(2))
      .replace('{{amount_no_decimals}}', String(Math.round(amount)));
  }

  escape(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);
  }

  getViewedProducts() {
    try {
      return JSON.parse(localStorage.getItem('wwfc_viewed') || '[]');
    } catch (_) {
      return [];
    }
  }

  parseProductIds(value) {
    return this.uniqueProductIds(String(value || '').split(','));
  }

  uniqueProductIds(values) {
    return [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];
  }

  routesRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  isComingSoon(product) {
    const tags = Array.isArray(product.tags) ? product.tags.join(',') : String(product.tags || '');
    return tags.toLowerCase().includes('coming soon') || String(product.template_suffix || '').toLowerCase() === 'comingsoon';
  }
}

document.querySelectorAll('.wwfc-test-slider').forEach((el) => new WWFCTestSlider(el));
document.querySelectorAll('.wwfc-test-carousel').forEach((el) => new WWFCTestCarousel(el));
document.querySelectorAll('.wwfc-test-recommendations').forEach((el) => new WWFCTestRecommendations(el));

{
  try {
    const id = window.ShopifyAnalytics?.meta?.product?.id || document.querySelector('[data-product-id]')?.dataset.productId;
    if (id) {
      const viewed = JSON.parse(localStorage.getItem('wwfc_viewed') || '[]');
      localStorage.setItem('wwfc_viewed', JSON.stringify([id, ...viewed.filter((item) => String(item) !== String(id))].slice(0, 12)));
    }
  } catch (_) {}
}
